import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";

import _  from 'underscore';
import "survey-react/survey.css";
//  import "./testing.css"

class Test extends Component {


  constructor(props){
    super(props)
    this.state = {
      thisIsMyCopy :'<p>copy copy copy <strong>strong copy</strong></p>',
      showinfo:false
     };
     
    
    }

    deleteData =(e)=> {
      e.preventDefault();
      this.props.deleteData(this.props.data.id)

      
    }

    showInfo = (e)=>{
      e.preventDefault();
    
      this.setState({
        showinfo:true
      })
      // console.log("show info", this.props.data, this.state.showinfo)
    }

    showclose=(e)=>{
      this.setState({
        showinfo:false
      })
    }

  

    



  render() {
    //  console.log("jidgksblk===---->", this.props.data)
     var classclouse = "input is-primary"
        if(this.props.data){
           if(this.props.data.inputType === "text" ){
            var inputText =`<input class="${classclouse}" type="${this.props.data.inputType}"  placeholder="${this.props.data.placeholder}" ${this.props.data.required === "true"? "required" : "" }/>`
              return (
                 
                <div className="">
                {
                  !this.state.showinfo?
                  <div>
                       <div className="text-form-builder-field-icon-body">
                        <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                        <a className="delete " onClick={this.deleteData}></a>
                       </div>
                     
                      <div className="text-form-builder-field">
                      
                        <div className="control"   >
                            <a style={{"cursor": 'not-allowed'}}> 
                                <div style={{ "pointerEvents": "none","cursor": 'not-allowed'}} dangerouslySetInnerHTML={{__html:   inputText}}></div>     
                            </a>
                        </div>
                      </div>
                  </div>
                  :
                  <div>
                     <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                     <div className="text-form-builder-field">
                         <table className="table is-bordered tutile-table-actitybody">
                          
                                            <tbody>
                                                   <tr>
                                                        <td>
                                                        <small className="tag">Name</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.inputType}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Title</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.title}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Placeholder</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.placeholder}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                   
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                            </tbody>
                                        </table>  
                             </div>
                  </div>
                  

                }
                     
                 </div>   
              )
           }else if(this.props.data.inputType === "email"){
            var inputemail =`<input class="${classclouse}" type="${this.props.data.inputType}"  placeholder="${this.props.data.placeholder}" ${this.props.data.required === "true"? "required" : "" }/>`
             return (
               <div>
                  {
                  !this.state.showinfo?
                  <div>
                      <div className="text-form-builder-field-icon-body">
                        <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                        <a className="delete " onClick={this.deleteData}></a>
                       </div>
                        <div className="text-form-builder-field">
                        <a style={{"cursor": 'not-allowed'}}> 
                                <div style={{ "pointerEvents": "none","cursor": 'not-allowed'}} dangerouslySetInnerHTML={{__html:   inputemail}}></div>     
                           </a>
                    </div>
                  </div>
                  :
                  <div>
                     <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                     <div className="text-form-builder-field">
                         <table className="table is-bordered tutile-table-actitybody">
                          
                                            <tbody>
                                                   <tr>
                                                        <td>
                                                        <small className="tag">Name</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.inputType}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Title</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.title}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Placeholder</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.placeholder}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                   
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                            </tbody>
                                        </table>  
                             </div>
                  </div>
                  }

               </div>
              
             )
           } else if(this.props.data.type === "comment" ){
          
           var inputarea =`  <textarea rows="4" cols="50"   class="textarea "   placeholder="${this.props.data.placeholder}" ${this.props.data.required === "true"? "required" : "" }/> </textarea>`
           return (
            <div>
                {
                  !this.state.showinfo?
                  <div>
                    
                      <div className="text-form-builder-field-icon-body">
                          <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                          <a className="delete " onClick={this.deleteData}></a>
                      </div> 
                      <div className="text-form-builder-field">
                         <a style={{"cursor": 'not-allowed'}}> 
                                <div style={{ "pointerEvents": "none","cursor": 'not-allowed'}} dangerouslySetInnerHTML={{__html: inputarea}}></div>     
                         </a>
                       </div>  
                  </div>
                  :
                  <div>
                     <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                     <div className="text-form-builder-field">
                         <table className="table is-bordered tutile-table-actitybody">
                          
                                            <tbody>
                                                   <tr>
                                                        <td>
                                                        <small className="tag">Name</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.type}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Title</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.title}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Placeholder</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.placeholder}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                   
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                            </tbody>
                                        </table>  
                             </div>
                  </div>
                }
            </div>
         
           )
            }  else if(this.props.data.type === "boolean" ){
              // console.log("---0000--->" ,"comment")
             var inputarea =`<input type="checkbox" ${this.props.data.required === "true"? "" : "required"} >  ${this.props.data.title}`
             return (
                <div>
                    {
                      !this.state.showinfo?
                      <div>
                        
                        <div className="text-form-builder-field-icon-body">
                          <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                          <a className="delete " onClick={this.deleteData}></a>
                        </div>
                            <div className="text-form-builder-field">
                              <a style={{"cursor":'not-allowed'}}> 
                                 <div style={{ "pointerEvents": "none","cursor":'not-allowed'}}  dangerouslySetInnerHTML={{__html: inputarea}}></div>    
                              </a>
                             </div>
                       
                          </div>
                       :
                       <div>
                          <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                          <div className="text-form-builder-field">
                              <table className="table is-bordered tutile-table-actitybody">
                          
                                            <tbody>
                                                   <tr>
                                                        <td>
                                                        <small className="tag">Name</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.type}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Title</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.title}</small>
                                                        </td>
                                                    </tr>
                                                    
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                   
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                            </tbody>
                                        </table>  
                             </div>
                  </div>
                    }      
                </div>
           
             )
            } else if(this.props.data.type === "file" ){
              // console.log("---0000--->" ,"comment")
             var inputarea =`<input type="${this.props.data.type}" ${this.props.data.required === "true"? "" : "required"} >`
             return (
          
              <div>
                  {
                    !this.state.showinfo?
                    <div>
                        <div className="text-form-builder-field-icon-body">
                          <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                          <a className="delete " onClick={this.deleteData}></a>
                       </div>
                          <div className="text-form-builder-field">
                            <a style={{"cursor": 'not-allowed'}}> 
                              <div style={{ "pointerEvents": "none","cursor": 'not-allowed'}}  dangerouslySetInnerHTML={{__html: inputarea}}></div>    
                               {this.props.data.title}
                            </a>
                        </div>
                      </div>
                      :
                      <div>
                          <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                          <div className="text-form-builder-field">
                              <table className="table is-bordered tutile-table-actitybody">
                          
                                            <tbody>
                                                  <tr>
                                                        <td>
                                                        <small className="tag">Name</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                        </td>
                                                    </tr>
                                                  
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.type}</small>
                                                        </td>
                                                    </tr>
                                                  
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Title</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.title}</small>
                                                        </td>
                                                    </tr>
                                                    
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                  
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                            </tbody>
                                        </table>  
                            </div>
                  </div>
                  }    
              </div>
             )
             } else if(this.props.data.type === "checkbox" ){
              // console.log("---0000--->" ,"boox")
             var inputcheckbox1 =`<input type="checkbox"  type="checkbox"/> ${this.props.data.choices[0]} `
             var inputcheckbox2 =`<input type="checkbox"  type="checkbox">  ${this.props.data.choices[1]}`
             return (
                   
              <div>
                {
                  !this.state.showinfo?
                  <div>
                      <div className="text-form-builder-field-icon-body">
                        <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                        <a className="delete " onClick={this.deleteData}></a>
                       </div>
                        <div className="text-form-builder-field">
                          <a style={{"cursor":'not-allowed'}}> 
                            <div style={{ "pointerEvents": "none","cursor":'not-allowed'}}  dangerouslySetInnerHTML={{__html: inputcheckbox1}}></div>      
                        
                            <div style={{ "pointerEvents": "none","cursor":'not-allowed'}}  dangerouslySetInnerHTML={{__html: inputcheckbox2}}></div> 
                          </a>   
                      </div>
                    </div>
                    :
                    <div>
                      <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                        <div className="text-form-builder-field">
                            <table className="table is-bordered tutile-table-actitybody">
                        
                                          <tbody>
                                                <tr>
                                                      <td>
                                                      <small className="tag">Name</small>
                                                      </td>
                                                      <td>
                                                      <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                      </td>
                                                  </tr>
                                                
                                                  <tr>
                                                      <td>
                                                      <small className="tag">Type</small>
                                                      </td>
                                                      <td>
                                                      <small className="tag activity-tag-font">{this.props.data.type}</small>
                                                      </td>
                                                  </tr>
                                                
                                                  <tr>
                                                      <td>
                                                      <small className="tag">Item 1</small>
                                                      </td>
                                                      <td>
                                                      <small className="tag activity-tag-font">{this.props.data.choices[0]}</small>
                                                      </td>
                                                  </tr>
                                                  <tr>
                                                      <td>
                                                      <small className="tag">Item 2 </small>
                                                      </td>
                                                      <td>
                                                      <small className="tag activity-tag-font">{this.props.data.choices[1]}</small>
                                                      </td>
                                                  </tr>

                                                  
                                                  <tr>
                                                      <td>
                                                      <small className="tag">Required</small>
                                                      </td>
                                                      <td>
                                                      <small className="tag activity-tag-font">
                                                      {
                                                
                                                        this.props.data.isRequired?
                                                          " True"
                                                          :
                                                          " False"
                                                        }
                                                      </small>
                                                      </td>
                                                  </tr>

                                          </tbody>
                                      </table>  
                          </div>
                </div>
                }
              </div>
             )
            }  else if(this.props.data.type === "html" ){
              // console.log("---0000--->" ,"boox")
                var html =`${this.props.data.html} `
            
             return (
                  <div>   
                    {
                      !this.state.showinfo?
                      <div>
                           <div className="text-form-builder-field-icon-body">
                            <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                            <a className="delete " onClick={this.deleteData}></a>
                          </div>
                            <div className="text-form-builder-field">
                              <a style={{"cursor":'not-allowed'}}> 
                               
                          
                              <div style={{ "pointerEvents": "none",cursor: 'not-allowed'}} dangerouslySetInnerHTML={{__html: html}}></div>      
                            </a>
                        </div>
                    </div>
                    :
                    <div>
                          <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                          <div className="text-form-builder-field">
                              <table className="table is-bordered tutile-table-actitybody">
                          
                                            <tbody>
                                                  
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.type}</small>
                                                        </td>
                                                    </tr>
                                                  
                                                  
                                                    
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                  
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                            </tbody>
                                        </table>  
                            </div>
                  </div>
                    }
                  </div>
           
             )
            }  else{
            var inputyle =`<input class="${classclouse}" type="${this.props.data.inputType}"   placeholder="${this.props.data.placeholder}" required/>`
            return (
              <div>
              {
                !this.state.showinfo?
                  <div>
                       <div className="text-form-builder-field-icon-body">
                        <a onClick={this.showInfo}> <b className="text-form-builder-field-icon"> <i className="fas fa-binoculars"></i></b></a>
                        <a className="delete " onClick={this.deleteData}></a>
                       </div>
                        <div className="text-form-builder-field">
                          <a style={{"cursor":'not-allowed'}}> 
                            <div style={{ "pointerEvents": "none","cursor": 'not-allowed'}}  dangerouslySetInnerHTML={{__html:    inputyle}}></div>     
                         </a>
                    </div>
                  </div>
                :
                <div>
                <a onClick={this.showclose}> <b className="text-form-builder-field-icon-red"> <i className="fas fa-times"></i></b></a>
                  <div className="text-form-builder-field">
                      <table className="table is-bordered tutile-table-actitybody">
                  
                                    <tbody>
                                          <tr>
                                                <td>
                                                <small className="tag">Name</small>
                                                </td>
                                                <td>
                                                <small className="tag activity-tag-font">{this.props.data.name}</small>
                                                </td>
                                            </tr>
                                          
                                            <tr>
                                                        <td>
                                                        <small className="tag">Type</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.inputType}</small>
                                                        </td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Title</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.title}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Placeholder</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">{this.props.data.placeholder}</small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                        <small className="tag">Required</small>
                                                        </td>
                                                        <td>
                                                        <small className="tag activity-tag-font">
                                                        {
                                                   
                                                          this.props.data.isRequired?
                                                            " True"
                                                            :
                                                            " False"
                                                          }
                                                        </small>
                                                        </td>
                                                    </tr>

                                    </tbody>
                                </table>  
                    </div>
                </div>
                 }
              </div>
            )
          }
         
        }else{
          return (
            <div>
               Empty form
            </div>
          )
        }

    // return (
    //             <div className="Home"> 
    //                  <div className="columns">     
    //                       <div className="column">
    //                       <div className="text-build-delete-body">
    //                          <a className="delete " onClick={this.deleteData}></a>
    //                       </div>
    //                                 <div className="tooltip" data-direction="bottom">
    //                                   {
    //                                       this.props.data.name?
    //                                        <div>
    //                                          <div className="tooltip__initiator">
    //                                             {this.props.data.name}
    //                                           </div>
    //                                           <div className="tooltip__item">
    //                                               Name
    //                                           </div>
    //                                        </div>
    //                                        :
    //                                        <div> Html Dispay</div>
    //                                     }
                                        
                                      
    //                                 </div>
    //                         <div className="columns is-mobile">
    //                           <div className="column is-half">
                                
    //                                 <div className="tooltip" data-direction="bottom">
    //                                   <div className="tooltip__initiator">
    //                                         {this.props.data.title}
    //                                   </div>
    //                                   <div className="tooltip__item">
    //                                     Title
    //                                   </div>
                                      
    //                                 </div>
                                
                                
    //                           </div>
    //                           <div className="column">
                             
                            
                                
    //                           </div>
    //                           <div className="column">
    //                           <div className="tooltip" data-direction="bottom">
    //                                       <div className="tooltip__initiator">
                                          
    //                                       {this.props.data.placeholder}
    //                                       </div>
    //                                       <div className="tooltip__item">
    //                                           Placeholder
    //                                       </div>
                            
    //                                 </div>
                                 
                                
    //                           </div>
    //                           <div className="column">
    //                             <div className="tooltip" data-direction="bottom">
    //                             {
    //                                    this.props.data.isRequired?
    //                                        <div>
    //                                          <div className="tooltip__initiator">
    //                                          {
    //                                                 // this.props.isRequired
    //                                                 this.props.data.isRequired?
    //                                                   " True"
    //                                                   :
    //                                                   " False"
    //                                                 } 
    //                                           </div>
    //                                           <div className="tooltip__item">
    //                                                Is Required
    //                                           </div> 
    //                                        </div>
    //                                        :
    //                                        <div> </div>
    //                                     }
                                  
                                                       
    //                               </div>
    //                           </div>
    //                           <div className="column">
    //                            <div className="tooltip" data-direction="bottom">
    //                                       <div className="tooltip__initiator">
    //                                        {
    //                                          this.props.data.inputType?
    //                                          (<p>{this.props.data.inputType}</p>)
    //                                          :
    //                                          (<p> {this.props.data.type}</p>)
    //                                        }
                                               
    //                                       </div>
    //                                       <div className="tooltip__item">                                               
    //                                                <p>Input Type</p> 
    //                                       </div>
                                      
    //                                 </div>
    //                           </div>
    //                       </div>
    //                     </div>
    //                     <div>
    //                         <div className="nameofchan-body">
                                  
    //                         </div>
    //                     </div>
    //                   </div>

    //                   <div className="name">
    //                   <div className="content" dangerouslySetInnerHTML={{__html:  this.state.thisIsMyCopy}}></div>
    //                   <div className="content" dangerouslySetInnerHTML={{__html:  input}}></div>   
    //                    {input}
    //                   </div>

    //             </div>
    //         )
        }
    }    
  export default  Test  ;      






// WEBPACK FOOTER //
// ./src/component/create/test.js